export const managerLegacyPaths = {
  entrevista: '/gestor/entrevista/legado',
};
